const translations = {
  en: {
    // General
    appName: "ColoBongo",
    tagline: "Your cozy coloring companion",
    // CODEX_PROMPT_84 : tagline du splash screen (rebrand)
    splashTagline: "Learn, inspire, share.",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    back: "Back",
    next: "Next",
    skip: "Skip",
    done: "Done",
    
    // Nav
    home: "Home",
    challenges: "Challenges",
    wall: "Wall",
    palettes: "Palettes",
    profile: "Profile",
    studio: "Studio",
    settings: "Settings",
    fridge: "Fridge",
    scan: "Scan",
    
    // Home
    welcomeBack: "Welcome back!",
    spinTheWheel: "Try Your Luck!",
    scanMyColoring: "Scan My Coloring",
    viewPalettes: "View Palettes",
    activeChallenge: "Active Challenge",
    noActiveChallenge: "No active challenge. Try the gacha!",
    quickActions: "Quick Actions",
    
    // Wheel
    spin: "SPIN!",
    spinning: "...",
    spinAgain: "Spin Again",
    acceptChallenge: "Accept Challenge",
    challengeAccepted: "Challenge Accepted!",
    yourChallenge: "Your Challenge",
    
    // XP & Levels
    level: "Level",
    xp: "XP",
    xpEarned: "XP Earned",
    levelUp: "Level Up!",
    amazing: "Amazing!",
    
    // Challenge
    imDone: "I'm Done!",
    challengeComplete: "Challenge Complete!",
    tips: "Tips",
    abandon: "Abandon Challenge",
    
    // Palettes
    paletteExplorer: "Palette Explorer",
    selectTheme: "Select a theme",
    yourBrands: "Your Brands",
    copiedToClipboard: "Copied to clipboard!",
    
    // AI Scan
    scanColoring: "Scan My Coloring",
    takePhoto: "Take Photo",
    chooseFromGallery: "Choose from Gallery",
    howToShare: "How would you like to share your coloring?",
    lookingGood: "Looking good?",
    tipsForBestResults: "Tips for best results:",
    goodLighting: "Good lighting",
    centerArtwork: "Center your artwork",
    avoidShadows: "Avoid shadows on the page",
    retake: "Retake",
    analyze: "Analyze!",
    analysisComplete: "Analysis Complete!",
    whatsWorkingGreat: "What's working great:",
    proTipsToLevelUp: "Pro tips to level up:",
    colorsDetected: "Colors I detected:",
    examiningColors: "Examining your color choices...",
    detectingShading: "Detecting shading techniques...",
    analyzingStyle: "Analyzing your unique style...",
    almostThere: "Almost there...",
    
    // Profile
    progress: "Progress",
    challengesCompleted: "Challenges Completed",
    currentStreak: "Current Streak",
    longestStreak: "Longest Streak",
    days: "days",
    badges: "Badges",
    history: "History",
    stats: "Stats",
    
    // Settings
    language: "Language",
    english: "English",
    french: "French",
    markerBrands: "Marker/Pencil Brands",
    aiMode: "AI Analysis Mode",
    simulation: "Simulation",
    realAI: "Real AI (Claude)",
    simulationDesc: "Free - Pre-written feedback",
    realAIDesc: "Uses AI credits for real analysis",
    installApp: "Install App",
    installInstructions: "Add ColoBongo to your home screen!",
    iphoneSteps: "iPhone: Tap Share > Add to Home Screen",
    androidSteps: "Android: Tap Menu > Add to Home Screen",
    supportColoBongo: "Support ColoBongo",
    supportDesc: "Love the app? Help us keep it free!",
    everyBitHelps: "Every coffee helps us add more features!",
    enableSounds: "Enable sounds",
    soundsDescription: "Cozy sounds on interactions",
    resetProgress: "Reset Progress",
    resetConfirm: "Are you sure? This will delete all your progress.",
    resetDone: "Progress has been reset.",
    about: "About",
    version: "Version",
    
    // Onboarding
    welcomeTitle: "Welcome to ColoBongo!",
    welcomeDesc: "Your cozy companion for paper coloring adventures.",
    whatDoYouUse: "What markers/pencils do you use?",
    selectBrands: "Select your brands (you can change this later)",
    letsGetStarted: "Let's get started!",
    chooseLanguage: "Choose your language",
    skillLevel: "Skill Level",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    getStarted: "Get Started!",
    
    // Donation
    kofiButton: "Ko-fi (0% fees)",
    paypalButton: "PayPal",

    // Frigo public — formulaire proprietaire (CODEX_PROMPT_82)
    frigoTiktokLabel: "Your TikTok handle",
    frigoTiktokHelper: "Without the @, it will be added automatically. Letters, numbers, dots or underscores. 24 characters max.",
    frigoTiktokInvalid: "Invalid handle: letters, numbers, dots or underscores only, 24 characters max.",
    frigoPencilLabel: "Your favorite markers",
    frigoPencilHelper: "Appears on your public Fridge",
    frigoPencilPlaceholder: "Choose a brand",
    frigoFormSaved: "Saved! ✨",
    frigoFormError: "Oops, something went wrong.",
  },
  fr: {
    // General
    appName: "ColoBongo",
    tagline: "Ton compagnon cozy de coloriage",
    // CODEX_PROMPT_84 : tagline du splash screen (rebrand)
    splashTagline: "Apprends, inspire, partage.",
    loading: "Chargement…",
    save: "Sauvegarder",
    cancel: "Annuler",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    skip: "Passer",
    done: "Terminé",
    
    // Nav
    home: "Accueil",
    challenges: "Défis",
    wall: "Mur",
    palettes: "Palettes",
    profile: "Profil",
    studio: "Studio",
    settings: "Réglages",
    fridge: "Frigo",
    scan: "Scan",
    
    // Home
    welcomeBack: "Bon retour !",
    spinTheWheel: "Tente ta chance !",
    scanMyColoring: "Scanner Mon Coloriage",
    viewPalettes: "Voir les Palettes",
    activeChallenge: "Défi Actif",
    noActiveChallenge: "Aucun défi actif. Tente ta chance !",
    quickActions: "Actions Rapides",
    
    // Wheel
    spin: "TOURNER !",
    spinning: "…",
    spinAgain: "Tourner Encore",
    acceptChallenge: "Accepter le Défi",
    challengeAccepted: "Défi Accepté !",
    yourChallenge: "Ton Défi",
    
    // XP & Levels
    level: "Niveau",
    xp: "XP",
    xpEarned: "XP Gagnés",
    levelUp: "Niveau Supérieur !",
    amazing: "Incroyable !",
    
    // Challenge
    imDone: "J’ai Fini !",
    challengeComplete: "Défi Terminé !",
    tips: "Conseils",
    abandon: "Abandonner le Défi",
    
    // Palettes
    paletteExplorer: "Explorateur de Palettes",
    selectTheme: "Choisis un thème",
    yourBrands: "Tes Marques",
    copiedToClipboard: "Copié dans le presse-papiers !",
    
    // AI Scan
    scanColoring: "Scanner Mon Coloriage",
    takePhoto: "Prendre une Photo",
    chooseFromGallery: "Choisir de la Galerie",
    howToShare: "Comment veux-tu partager ton coloriage ?",
    lookingGood: "Ça a l’air super ?",
    tipsForBestResults: "Conseils pour de meilleurs résultats :",
    goodLighting: "Bon éclairage",
    centerArtwork: "Centre ton œuvre",
    avoidShadows: "Évite les ombres sur la page",
    retake: "Reprendre",
    analyze: "Analyser !",
    analysisComplete: "Analyse Terminée !",
    whatsWorkingGreat: "Ce qui fonctionne bien :",
    proTipsToLevelUp: "Conseils pro pour progresser :",
    colorsDetected: "Couleurs détectées :",
    examiningColors: "Examen de tes choix de couleurs…",
    detectingShading: "Détection des techniques d’ombrage…",
    analyzingStyle: "Analyse de ton style unique…",
    almostThere: "Presque fini…",
    
    // Profile
    progress: "Progression",
    challengesCompleted: "Défis Complétés",
    currentStreak: "Série en Cours",
    longestStreak: "Plus Longue Série",
    days: "jours",
    badges: "Badges",
    history: "Historique",
    stats: "Statistiques",
    
    // Settings
    language: "Langue",
    english: "Anglais",
    french: "Français",
    markerBrands: "Marques de Marqueurs/Crayons",
    aiMode: "Mode d’Analyse IA",
    simulation: "Simulation",
    realAI: "IA Réelle (Claude)",
    simulationDesc: "Gratuit - Retours pré-écrits",
    realAIDesc: "Utilise des crédits IA pour une vraie analyse",
    installApp: "Installer l’App",
    installInstructions: "Ajoute ColoBongo à ton écran d’accueil !",
    iphoneSteps: "iPhone : Appuie sur Partager > Ajouter à l’écran d’accueil",
    androidSteps: "Android : Appuie sur Menu > Ajouter à l’écran d’accueil",
    supportColoBongo: "Soutenir ColoBongo",
    supportDesc: "Tu aimes l’app ? Aide-nous à la garder gratuite !",
    everyBitHelps: "Chaque café nous aide à ajouter plus de fonctionnalités !",
    enableSounds: "Activer les sons",
    soundsDescription: "Sons cozy lors des interactions",
    resetProgress: "Réinitialiser la Progression",
    resetConfirm: "Es-tu sûr(e) ? Cela supprimera toute ta progression.",
    resetDone: "La progression a été réinitialisée.",
    about: "À Propos",
    version: "Version",
    
    // Onboarding
    welcomeTitle: "Bienvenue sur ColoBongo !",
    welcomeDesc: "Ton compagnon cozy pour les aventures de coloriage.",
    whatDoYouUse: "Quels marqueurs/crayons utilises-tu ?",
    selectBrands: "Sélectionne tes marques (tu pourras changer plus tard)",
    letsGetStarted: "C’est parti !",
    chooseLanguage: "Choisis ta langue",
    skillLevel: "Niveau",
    beginner: "Débutant",
    intermediate: "Intermédiaire",
    advanced: "Avancé",
    getStarted: "Commencer !",
    
    // Donation
    kofiButton: "Ko-fi (0% frais)",
    paypalButton: "PayPal",

    // Frigo public — formulaire proprietaire (CODEX_PROMPT_82)
    frigoTiktokLabel: "Ton pseudo TikTok",
    frigoTiktokHelper: "Sans le @, il sera ajouté automatiquement. Lettres, chiffres, points ou underscores. 24 caractères max.",
    frigoTiktokInvalid: "Pseudo invalide : lettres, chiffres, points ou underscores uniquement, 24 caractères max.",
    frigoPencilLabel: "Tes crayons préférés",
    frigoPencilHelper: "Apparaît sur ton Frigo public",
    frigoPencilPlaceholder: "Choisir une marque",
    frigoFormSaved: "C'est sauvegardé ! ✨",
    frigoFormError: "Oups, une erreur s'est produite.",
  }
};

export default translations;

